import { PostMessage } from "../iframe/iframe.state"

export type ScrollToTopMessage = PostMessage & { }

export type ConfirmationMessage = PostMessage & {
  session_id: string
  is_confirmed: boolean
}

export type SubmissionMessage = PostMessage & {
  price_exl_vat: string
  price_inc_vat: string
  registration_type: RegistrationType
  eventTemplate_id: string
  eventTemplate_name: string
  participantsCount: number
  session_id: string
}

export enum RegistrationType {
  "Lid van evofenedex" = 914060000,
  "Geen lid van evofenedex" = 914060001,
  "Particulier" = 914060002
}
